import React from 'react';
import { ConfigProvider } from './context/ConfigProvider';
import { PclnUcChatBot } from './PclnUcChatBot';
/**
 * TheChatBot
 * @public
 */
export const TheChatBot = props => {
  const propDrill = {
    componentVersion: props.componentVersion,
    discoveryCitySelected: props.discoveryCitySelected,
    handleMarkerResponse: props.handleMarkerResponse,
    isChatBoxOpened: props.isChatBoxOpened,
    markerComponents: props.markerComponents,
    onChatDialogRendered: props.onChatDialogRendered,
    onClose: props.onClose
  };
  return React.createElement(ConfigProvider, {
    customerName: props.customerName,
    isChatBoxOpened: props.isChatBoxOpened,
    locale: props.locale,
    viewType: props.viewType,
    webstats: props.webstats,
    startingChatMessagesPayload: props.startingChatMessagesPayload
  }, (resolvedConfig, resolvedDisplay, resolvedFeatures, resolvedPayload) => {
    return React.createElement(PclnUcChatBot, Object.assign({
      resolvedFeatures: resolvedFeatures,
      resolvedConfig: resolvedConfig,
      resolvedDisplay: resolvedDisplay,
      resolvedPayload: resolvedPayload
    }, propDrill));
  });
};